// English translations — member portal
export const portalEn = {
  header: {
    churchName: 'Our Lady of Fatima Church',
    openMenu: 'Open menu',
    accountMenu: 'Account menu',
    signOut: 'Sign out',
  },
  nav: {
    overview: 'Overview',
    dashboard: 'Dashboard',
    analytics: 'Analytics',
    zoneMap: 'Zone Map',
    anbiyam: 'Anbiyam',
    families: 'Families',
    subscriptions: 'Subscriptions',
    bulkExport: 'Bulk Export',
    collectionReview: 'Collection Sheet Scans',
    cemetery: 'Cemetery',
    parish: 'Parish',
    nonParish: 'Non-Parish',
    certificates: 'Certificates',
    userMgmt: 'User Management',
    users: 'Users',
    activityLog: 'Activity Log',
  },
  login: {
    churchName: 'Our Lady of Fatima Church',
    location: 'Tambaram, Chennai',
    username: 'Username',
    password: 'Password',
    signIn: '✝  Sign In',
    signingIn: 'Signing in…',
    credentials: 'Use your assigned church credentials',
    copyright: '© Fatima Church, Tambaram',
    errorRequired: 'Username and password are required.',
    errorInvalid: 'Invalid username or password. Please try again.',
  },
} as const;
